import React from 'react'
import Box from '@mui/material/Box'
import CellBadge from '../CellBadge'
import { Typography } from '@mui/material'
import { grey } from '../../../../colors'
import { InsightTooltip, type OverflowClickHandler } from '../OverflowIndicator'

interface MultiBadgeProps {
  list: string[]
  maxVisible?: number
  disabled?: boolean
  onOverflowClick?: OverflowClickHandler
}

const MultiBadge: React.FC<MultiBadgeProps> = ({ list, maxVisible = 1, disabled = false, onOverflowClick }) => {
  const visibleBadge = list.slice(0, maxVisible)
  const remainingBadges = list.slice(maxVisible)
  const overflowCount = Math.max(list.length - maxVisible, 0)

  const Title = (): JSX.Element => {
    return (
      <Box display={'flex'} gap={1} flexWrap={'wrap'}>
        {remainingBadges?.map((item: string, index: number) => {
          const isLast = index === remainingBadges.length - 1
          return (
            <Typography key={`${item}-${index}`} fontWeight={600} color={grey[0]} fontSize={'12px'}>
              {isLast ? item : `${item},`}
            </Typography>
          )
        })
        }
      </Box >
    )
  }

  return (
    <Box display="flex" alignItems={'center'} flexWrap={'wrap'} gap={2}>
      {visibleBadge?.map((item: string, index: number) => (
        <CellBadge label={item} key={index} disabled={disabled} />
      ))}

      {overflowCount > 0 && (
        <Box onClick={onOverflowClick} sx={onOverflowClick ? { cursor: 'pointer' } : undefined}>
          <InsightTooltip count={overflowCount} tooltipTitle={<Title />} onClick={onOverflowClick}>
            <CellBadge sx={{ fontSize: 14 }} label={`+${overflowCount}`} disabled={disabled} />
          </InsightTooltip>
        </Box>
      )}

    </Box>
  )
}

export default MultiBadge
